export enum LocalStorageEnum {
  EMAIL_COUPON_ACCEPT= 'emailCouponAccept', // BetaUser email (ex: 'juan.perez@mail.com')
  COUPON_NAME_ACCEPT = 'couponNameAccept', // BetaUser encode coupon (ex: 'QkVUQV9VU0VSX0NPVVBPTi0xNjc2ODQ4Mzk4MzY4LTlmYmJkZDk2Yg==')
  IS_BETA_USER = 'isBetaUser', // if BetaUser saves (ex: 'TRUE')
  USER = 'user',
  FORCE_TOUR_NAME = 'forceTourName', // Inicia un tour desde la vista de tours
}
